import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "text-lg" }
const _hoisted_2 = {
  id: "btn-action-add",
  class: "flex justify-end"
}
const _hoisted_3 = { class: "flex justify-between items-center gap-3" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "w-full flex flex-col gap-2" }
const _hoisted_6 = {
  id: "actions",
  class: "flex justify-end items-center gap-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Errors = _resolveComponent("Errors")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
    class: "flex flex-col gap-5 pt-5 border-t"
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t("labels.generic", {
          pt: "As opções adicionais servirão apenas para aumentar o engajamento e testar o conhecimento dos participantes, portanto NÃO serão consideradas corretas.",
          en:"The aditional options it's only for increase engagement and test participants' knowledge, therefore it will NOT be considered right"
        })), 1),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.exceedOptions(5))
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: _ctx.$t('labels.generic', {pt:'Adicionar opção', en:'Add option'}),
            icon: "pi pi-plus",
            class: "btn-simple w-fit",
            onClick: _withModifiers(_ctx.addOption, ["prevent"])
          }, null, 8, ["label", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (input, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("i", {
            id: "remove-gap-action",
            class: "pi pi-minus mt-6 bg-h-warning-700 rounded-full p-1 text-white cursor-pointer hover:scale-90 transition-all mb-5",
            onClick: _withModifiers(($event: any) => (_ctx.removeOption(index)), ["prevent"])
          }, null, 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", null, _toDisplayString("Opção adicional " + (index + 1)), 1),
            _createVNode(_component_InputText, {
              modelValue: input.name,
              "onUpdate:modelValue": ($event: any) => ((input.name) = $event),
              maxLength: 200
            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
            _createVNode(_component_Errors, {
              errors: 
              _ctx.questionStore.v$Dialog.$dirty
                ? _ctx.questionStore.v$Dialog.options.$each.$response.$errors[index]
                    ?.name
                : []
            ,
              actualLength: input.name.length,
              maxLength: 200
            }, null, 8, ["errors", "actualLength"])
          ])
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_Button, {
        label: "Cancelar",
        class: "btn-outline",
        onClick: _withModifiers(_ctx.onClose, ["prevent"])
      }, null, 8, ["onClick"]),
      _createVNode(_component_Button, {
        label: "Confirmar",
        class: "btn-primary",
        onClick: _withModifiers(_ctx.submit, ["prevent"])
      }, null, 8, ["onClick"])
    ])
  ], 32))
}